export default {"src":"/_next/static/media/greenbeans.0db15c41.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};